import { Link, Navigate } from 'react-router-dom';
import { AuthSplit } from '../../components/bidder-web';
import { ForgotPasswordForm } from '../../components/ForgotPasswordForm';
import { useSession } from '../../hooks/useSession';
import { authRedirectUrl } from '../../lib/authRedirect';

/**
 * Bidder password recovery (shared app).
 *
 * Rebuilt into the auth split (2026-09-03). The RECOVERY FLOW is untouched:
 * `ForgotPasswordForm` triggers the Supabase reset email, whose link lands on
 * `/auth/callback?next=/auth/reset-password`.
 *
 * The reassurance is the point of the copy here. Someone resetting a password
 * mid-sale is worried about their bids, so the page says plainly that nothing
 * they have set is affected.
 */
export function BidderForgotPassword() {
  const { session, loading } = useSession();
  if (!loading && session) {
    return <Navigate to="/" replace />;
  }

  return (
    <AuthSplit>
      <div>
        <h2 className="w-h2">Reset your password</h2>
        <p className="w-body muted" style={{ marginTop: 8 }}>
          We will email you a link. Your bids, maximums and watchlist are untouched — a maximum you
          have already set keeps bidding while you do this.
        </p>
      </div>
      <ForgotPasswordForm
        resetRedirectTo={authRedirectUrl('/auth/callback?next=/auth/reset-password')}
      />
      <Link to="/signin" className="w-btn w-btn-quiet w-btn-full">
        Back to sign in
      </Link>
    </AuthSplit>
  );
}
